// Copyright 2021 Pangea Cyber Corporation
// Author: Pangea Cyber Corporation

import { create } from "zustand";

interface WebsiteState {
  modalAiChallengeRegisterOpen: boolean;
  modalAiChallengeShareOpen: boolean;
  actions: {
    openModalAiChallengeRegister: () => void;
    closeModalAiChallengeRegister: () => void;
    openModalAiChallengeShare: () => void;
    closeModalAiChallengeShare: () => void;
  };
}

export const useWebsiteStore = create<WebsiteState>()((set) => ({
  modalAiChallengeRegisterOpen: false,
  modalAiChallengeShareOpen: false,
  actions: {
    openModalAiChallengeRegister: () =>
      set({
        modalAiChallengeRegisterOpen: true,
      }),
    closeModalAiChallengeRegister: () =>
      set({
        modalAiChallengeRegisterOpen: false,
      }),
    openModalAiChallengeShare: () =>
      set({
        modalAiChallengeShareOpen: true,
      }),
    closeModalAiChallengeShare: () =>
      set({
        modalAiChallengeShareOpen: false,
      }),
  },
}));
